var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"modal",staticClass:"modal fade layoutSize layout pAbs modal__container",attrs:{"data-backdrop":"static"}},[_c('div',{staticClass:"modal__wrapper modal-dialog"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }